import { render } from "./BillStatic.vue?vue&type=template&id=1e8d553d"
import script from "./BillStatic.vue?vue&type=script&lang=js"
export * from "./BillStatic.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__